import { useEffect, useMemo } from "react";
import { Redirect, useParams } from "react-router-dom";

import styled from "styled-components/macro";

import { useNewSignupCreationFlow } from "Signups/SignupView/NewSignup";
import { useSignups } from "Signups/state";
import { useIsSignupEditMode } from "Signups/stateHooks";

import AskForNewItem from "./AskForNewItem";
import CustomizeSignupOptions from "./CustomizeSignupOptions";
import EditSignupItem from "./EditSignupItem";
import ItemsList from "./ItemsList";

export default function SignupItems() {
  const [
    {
      currentSignupList: { signupItems: items },
    },
  ] = useSignups();

  const { signupTab, signupItemID, signupListID } = useParams();

  const { isInCreationFlow, cancelCreationFlow, lastCreatedSignupItemID } =
    useNewSignupCreationFlow();
  const { setIsSignupEditMode } = useIsSignupEditMode();

  const itemID = Number(signupItemID);
  const itemExists = useMemo(
    () => Boolean(itemID > 0 && items.find(({ ID }) => ID === itemID)),
    [itemID, items]
  );
  const isCustomize = signupItemID === "customize";
  const isValidItemID =
    itemExists ||
    isCustomize ||
    signupItemID === "new" ||
    signupItemID === "another";

  useEffect(() => {
    if (
      signupItemID &&
      (itemExists || isCustomize) &&
      !lastCreatedSignupItemID
    ) {
      setIsSignupEditMode(true);
    }

    if (
      !signupItemID ||
      signupItemID === "new" ||
      signupItemID === "another" ||
      !isInCreationFlow ||
      !lastCreatedSignupItemID
    )
      return;

    if (Number(signupItemID) !== lastCreatedSignupItemID) cancelCreationFlow();
  }, [
    signupItemID,
    itemExists,
    isInCreationFlow,
    lastCreatedSignupItemID,
    setIsSignupEditMode,
    cancelCreationFlow,
    isCustomize,
  ]);

  if (signupTab === "items" && !isValidItemID) {
    const redirectToItemID = items.length > 0 ? items[0].ID : "new";
    return (
      <Redirect to={`/signups/${signupListID}/items/${redirectToItemID}`} />
    );
  }

  return (
    <Wrapper data-cy="signupItemsWrapper">
      <ItemsList items={items} />
      <ContentWrapper>
        {isCustomize ? (
          <CustomizeSignupOptions />
        ) : signupItemID === "another" ? (
          <AskForNewItem />
        ) : (
          isValidItemID && <EditSignupItem />
        )}
      </ContentWrapper>
    </Wrapper>
  );
}

const Wrapper = styled.div`
  display: flex;
  height: 100%;
  width: 100%;
  position: relative;

  @media (max-width: 1060px) {
    flex-direction: column;
  }
`;
const ContentWrapper = styled.div`
  padding-bottom: 100px;
  flex-grow: 1;
  max-height: 100%;

  @media (min-width: 1061px) {
    overflow: auto;
  }
`;
